// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AFFKx","content":"styles_content__lflwq","row":"styles_row__3fW6L","footer":"styles_footer__2FFTs","phraseLength":"styles_phraseLength__3rRSH"};